const PUBLIC_URL = process.env.PUBLIC_URL || process.env.REACT_APP_DEV_PUBLIC_URL;

export const publicUrl = (path: string): string => `${PUBLIC_URL}${path}`;
